import * as React from 'react';
import { SkeletonLoader } from '@ally/metronome-ui';
export const RepickSkeletonLoader = () => (React.createElement(SkeletonLoader.Container, null,
    React.createElement(SkeletonLoader.Row, { height: "xl", width: "m" }),
    React.createElement(SkeletonLoader.Row, { height: "xl", width: "m" }),
    React.createElement(SkeletonLoader.Row, { height: "xl", width: "m" })));
//# sourceMappingURL=RepickSkeletonLoader.js.map